<div class="container-fluid">
  <div class="alert alert-danger m-2 rounded" role="alert">
    <div class="ml-2">{{'UNAUTHORIZED_USER' | translate }}</div>
  </div>
</div>

<div class="row justify-content-center">
  <button class="btn btn-link" (click)="logout()"><u>{{'SIDEBAR.USER.LOGOUT' | translate}}</u></button>
</div>